import React from 'react'
import { waitingBg } from '../assets'
import { useNavigate } from 'react-router-dom'

const Waiting = () => {

  const navigate = useNavigate()

  const styles = {
    backgroundImage: `url(${waitingBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center' 
  }

  return (
    <div style={styles} className="flex flex-col justify-center items-center text-center w-full md:h-[350px] rounded-xl cursor-pointer md:pl-10 px-4 py-10 mb-[60px] text-white">
      <h2 className="md:text-3xl text-2xl font-bold md:w-[45%] uppercase">
      Come experience pampering at affordable prices!!
      </h2>
      <p className="mt-4 mb-6 md:w-[55%] leading-relaxed">
      Whether you need a short-term rental, an extended stay, or a luxurious living experience, The Imperial by WosAm is the perfect choice.
      </p>
      <div className="flex items-center gap-4">
        <button className="md:py-3 py-2 md:px-6 px-4 md:text-base text-sm text-black bg-primary outline-1 outline outline-primary rounded-md font-bold"
        onClick={() => navigate('/booking')}
        >
          BOOK ROOM
        </button>
        <a 
          href='mailto:info@wosamapartments.com'
          className="md:py-3 py-2 md:px-6 px-4 md:text-base text-sm text-white bg-transparent outline outline-1 outline-white rounded-md font-bold"
        >
          CONTACT US
        </a>
      </div>
    </div>
  )
}

export default Waiting